import NotificationsMixin from "./NotificationsMixin";
import UnsavedChangesMixin from "./UnsavedChangesMixin";
import scrollTop from "../services/scroll_top";
import { pluralize } from "../helpers";

export default {
  mixins: [NotificationsMixin, UnsavedChangesMixin],

  computed: {
    response () {
      return this.responseStore.response || {};
    },

    resource () {
      return this.response.resource;
    },

    collection () {
      return this.response.collection;
    }
  },

  methods: {
    async createFormSubmitted (e, params = this.$route.params) {
      tinyMCE.triggerSave();

      this.handleResponse(await this.store.create(params));
    },

    async updateFormSubmitted (e, params = this.$route.params) {
      tinyMCE.triggerSave();

      this.handleResponse(await this.store.update(this.resource.id, params));
    },

    async saveFormSubmitted (e, params = this.$route.params) {
      tinyMCE.triggerSave();

      this.handleResponseToShow(await this.store.update(this.resource.id, params));
    },

    async clickDestroy (e, params = this.$route.params) {
      this.handleResponse(await this.store.delete(this.resource.id, params));
    },

    async clickCancel (e, params = this.$route.params) {
      this.handleResponse(await this.store.cancel(this.resource.id, params));
    },

    indexTitle (name, count) {
      if (count) {
        return `${count} ${pluralize(name, count)}`;
      } else {
        return pluralize(name, count);
      }
    },

    handleResponse (response, successCallback = function () {}) {
      if (response.success) {
        this.formChanged = false;
        this.navigateToIndexRoute();
        this.notifySuccess(response.successMessage);
        successCallback(response);
      } else {
        this.notifyErrors(response.errorMessages);

        scrollTop();
      }
    },

    handleResponseToShow (response) {
      if (response.success) {
        this.formChanged = false;
        this.navigateToShowRoute(response);
        this.notifySuccess(response.successMessage);
      } else {
        this.notifyErrors(response.errorMessages);

        scrollTop();
      }
    },

    handleResponseInplace (response) {
      if (response.success) {
        this.notifySuccess(response.successMessage);
        this.$nextTick(() => {
          this.formChanged = false;
        });
      } else {
        this.notifyErrors(response.errorMessages);
      }

      scrollTop();

      return response;
    },

    handleResponseToIndex (responseJSON) {
      if (responseJSON.success) {
        this.formChanged = false;
        this.navigateToIndexRoute();
        this.notifySuccess(responseJSON.successMessage);
      } else {
        this.notifyErrors(responseJSON.errorMessages);
      }

      scrollTop();
    },

    handleResponseToNew (response, successCallback = function () {}) {
      if (response.success) {
        this.formChanged = false;
        this.navigateToNewRoute();
        this.notifySuccess(response.successMessage);
        successCallback(response);
      } else {
        this.notifyErrors(response.errorMessages);
      }

      scrollTop();

      return response;
    },

    handleResponseToEdit (response) {
      if (response.success) {
        this.formChanged = false;
        this.navigateToEditRoute(response);
        this.notifySuccess(response.successMessage);
      } else {
        this.notifyErrors(response.errorMessages);
      }

      scrollTop();

      return response;
    }
  }
};
